"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPrimaryButtonLink = exports.FloatingPrimaryButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const primary_1 = require("./primary");
exports.FloatingPrimaryButton = (0, styled_1.default)(primary_1.PrimaryButton) `
  padding-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')};
  box-shadow: ${(0, ui_theme_1.fromTheme)('box_shadow_floating_button')};
`;
exports.FloatingPrimaryButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.FloatingPrimaryButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=floating-primary.js.map